import React, { Component } from 'react'
import PropTypes from 'prop-types'

import styles from './Slider.module.styl'
import { setTimeout } from 'timers'

let autoLoop = null

class Slider extends Component {
  static propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
      alt: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired
    })).isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      currentImageIndex: 0,
      sliderWidth: 0
    }

    this._boundWidthListener = this._widthListener.bind(this)
  }

  componentDidMount = () => {
    setTimeout(() => {
      this.setState({ sliderWidth: this.sliderElement.offsetWidth })
    }, 500)

    window.addEventListener('resize', this._boundWidthListener)
    this._autoLoop('start')
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this._boundWidthListener)
    this._autoLoop('stop')
  }

  _widthListener = () => {
    this.setState({ sliderWidth: this.sliderElement.offsetWidth })
  }

  _previousSlide = () => {
    const { currentImageIndex } = this.state
    const { images } = this.props

    this.setState({
      currentImageIndex: currentImageIndex === 0
        ? images.length - 1
        : currentImageIndex - 1
    })
  }

  _nextSlide = () => {
    const { currentImageIndex } = this.state
    const { images } = this.props

    this.setState({
      currentImageIndex: currentImageIndex === (images.length - 1)
        ? 0
        : currentImageIndex + 1
    })
  }

  _autoLoop = (state) => {
    if (state === 'start') {
      autoLoop = setInterval(() => {
        this._nextSlide()
      }, 8000)
    } else {
      clearInterval(autoLoop)
    }

    return null
  }

  _renderImages = () => {
    return this.props.images.map((image, index) => (
      <div
        key={index}
        className={styles.imageContainer}
        style={{ left: `-${this.state.currentImageIndex * this.state.sliderWidth}px` }}
      >
        <img src={image.image} alt={image.alt} className={styles.imageTag} />
      </div>
    ))
  }

  render() {
    return (
      <div
        className={styles.slider}
        ref={(div) => { this.sliderElement = div }}
        onMouseEnter={() => { this._autoLoop('stop') }}
        onMouseLeave={() => { this._autoLoop('start') }}
      >
        <div className={styles.controls}>
          <button className={styles.controlLeft} onClick={() => { this._previousSlide() }}>‹</button>
          <button className={styles.controlRight} onClick={() => { this._nextSlide() }}>›</button>
        </div>

        {this._renderImages()}
      </div>
    )
  }
}

export default Slider



// WEBPACK FOOTER //
// ./src/components/Slider/Slider.js